import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    requiresAuthenticationTitle: {
        id: '_.processing_payment.modal.requires_authentication_title',
        defaultMessage: 'A quick security check'
    }
});
